import { Stack, useTheme } from "@mui/material";
import { Post } from "src/api/client-api/post/postSchema";
import { SsqSsqHeading, SsqVersion } from "src/api/sure-api/ssq/useGetOneSsqVersion";
import { MRT_TableOptions } from "material-react-table";
import { ReactNode } from "react";
import { LockPostModal } from "./LockPostModal/LockPostModal";
import { HeadingList } from "./HeadingList/HeadingList";
import { QuestionnaireListProvider } from "./context/provider";
import { QuestionnaireListHeader } from "./QuestionnaireListHeader";
import { ScoresSection } from "./ScoresSection";
import { StalePostModal } from "./StalePostModal";
import { ExportSubject } from "src/utils/exportNaming";

export type HeadingsSectionData = {
    ssqSsqHeading: SsqSsqHeading;
    completion?: number | null;
};

type QuestionnairesListProps = {
    ssqVersion?: SsqVersion;
    post?: Post;
    isSsqLoading: boolean;
    isPostLoading: boolean;
    completeQuestionnaireUrl: (ssqSsqHeading: SsqSsqHeading) => string;
    scoresSection: ReactNode;
    displayDateLastModified?: boolean;
    enableTableHead?: boolean;
    muiTableProps?: Omit<MRT_TableOptions<HeadingsSectionData>["muiTableProps"], "columns" | "data">;
    title?: string;
    exportSubject: ExportSubject;
};

export const QuestionnairesList = (props: QuestionnairesListProps) => {
    return (
        <QuestionnaireListProvider {...props}>
            <InnerQuestionnaireList />
        </QuestionnaireListProvider>
    );
};

const InnerQuestionnaireList = () => {
    const theme = useTheme();

    return (
        <Stack gap={theme.spacing(3)}>
            <LockPostModal />
            <StalePostModal />
            <QuestionnaireListHeader />
            <Stack flexDirection={{ xs: "column", lg: "row" }} gap={theme.spacing(3.5)}>
                <Stack width={{ lg: "75%", xs: "100%" }}>
                    <HeadingList />
                </Stack>

                <ScoresSection />
            </Stack>
        </Stack>
    );
};
